import React from 'react';
import { Route, RouteComponentProps } from "react-router-dom";
import { Footer } from './components/footer';
import { Map, MapParams } from './pages/map';
import './App.css';
import { Api } from './components/googlemaps/api';
import { Settings } from './models/settings';
import { FlightAwareHub } from './signalr/flightawarehub';
import { fetchJson } from './util';

interface AppState {
    settings?: Settings,
    flightAwareHub?: FlightAwareHub | null
}

class App extends React.PureComponent<{}, AppState> {

    state: AppState = {};

    componentDidMount() {
        fetchJson<Settings>('/api/settings')
            .then(settings => this.setState({ settings }));
    }

    renderMap = (props: RouteComponentProps<MapParams>) => this.state.settings && this.state.flightAwareHub && <Map flightAwareHub={this.state.flightAwareHub} {...props}  />
        
    render() {
        return (
            <div>
                {this.state.settings && <Api apiKey={this.state.settings.mapsApiKey} />}
                {this.state.settings && <FlightAwareHub ref={(flightAwareHub) => this.setState({ flightAwareHub })} url={this.state.settings.flightAwareHubUrl} />}                
                <Route exact path='/flight/:flightToken' render={this.renderMap} />
                <Footer />
            </div>
        );
    }
}

export default App;
